import { ref } from 'vue';

import { DateWorkingMode } from '../models/entities/calendar.model';
import { SlideInformation } from '../models/entities/text-carousel.model';
import { TimeOption } from '../models/entities/timeslot.model';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars
const useCalendarPicker = ({ emit }) => {
  // ----------------------------------------
  // variables
  const activeCarouselSlide = ref(0);

  // ----------------------------------------
  // methods
  const changeDate = (date: Date): void => {
    emit('changeDate', date);
  };

  const changeSheet = (page: SlideInformation): void => {
    activeCarouselSlide.value = page.index;
  };

  const changeTime = (time: TimeOption, workingMode: DateWorkingMode): void => {
    emit('changeTime', time, workingMode);
  };

  const maskCalendarSection = (): void => {
    emit('maskCalendar');
  };

  const onPickerToggle = (
    $event: boolean,
    workingMode: DateWorkingMode
  ): void => {
    emit('onPickerToggle', $event, workingMode);
  };

  const unmaskCalendarSection = (): void => {
    emit('unmaskCalendar');
  };

  return {
    activeCarouselSlide,
    changeDate,
    changeSheet,
    changeTime,
    onPickerToggle,
    maskCalendarSection,
    unmaskCalendarSection,
  };
};

export default useCalendarPicker;
